import { Link as RouterLink } from "react-router-dom";
import { Center, VStack, Heading, Text, Button } from "@chakra-ui/react";

export default function NotFoundPage() {
  return (
    <Center minH="100vh" bg="app-page">
      <VStack spacing={4} textAlign="center">
        <Heading size="2xl" color="primary">
          404
        </Heading>
        <Text color="app-muted-fg">Esta página não existe.</Text>
        <Button as={RouterLink} to="/dashboard">
          Voltar para o início
        </Button>
      </VStack>
    </Center>
  );
}
